export default __webpack_public_path__ + "static/media/ico-iptu.6e7cf5b7.svg";